// PDF del riepilogo compensi del segnalatore (pratiche selezionate).
import { jsPDF } from "jspdf";
import { formatEuro } from "./format";

export function buildRiepilogoCompensiPdf({ segnalatore, periodo, pratiche, showOnorari = true, showSpese = true, header = null }) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const M = 14;
  let y = 18;

  if (header) {
    let tx = M;
    if (header.logo) {
      try {
        const props = doc.getImageProperties(header.logo);
        const h = 16, w = Math.min(45, (props.width / props.height) * h);
        doc.addImage(header.logo, M, y - 6, w, w === 45 ? (45 * props.height) / props.width : h);
        tx = M + w + 5;
      } catch { /* logo non valido: ignora */ }
    }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(String(header.nome || ""), tx, y);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    doc.setTextColor(90);
    let hy = y + 4.5;
    (header.righe || []).filter(Boolean).forEach((r) => { doc.text(String(r), tx, hy); hy += 4; });
    doc.setTextColor(0);
    y = Math.max(hy, y + 14) + 2;
    doc.setDrawColor(15, 118, 110);
    doc.setLineWidth(0.6);
    doc.line(M, y, 196, y);
    doc.setLineWidth(0.2);
    y += 8;
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Riepilogo compensi segnalatore", M, y);
  y += 7;
  doc.setFontSize(12);
  doc.text(String(segnalatore || ""), M, y);
  y += 6;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(90);
  if (periodo) { doc.text(periodo, M, y); y += 5; }
  doc.text("Generato il " + new Date().toLocaleDateString("it-IT"), M, y);
  y += 7;
  doc.setTextColor(0);

  const extraW = (showOnorari ? 0 : 24) + (showSpese ? 0 : 22);
  const cols = [
    { k: "numero", t: "N\u00b0 Pratica", w: 26, a: "left" },
    { k: "cliente", t: "Ragione sociale", w: 60 + extraW, a: "left" },
    { k: "stato", t: "Stato", w: 24, a: "left" },
    ...(showOnorari ? [{ k: "onorari", t: "Onorari", w: 24, a: "right", money: true }] : []),
    ...(showSpese ? [{ k: "spese", t: "Spese", w: 22, a: "right", money: true }] : []),
    { k: "compenso", t: "Compenso", w: 26, a: "right", money: true },
  ];
  const xs = [];
  let cx = M;
  cols.forEach((c) => { xs.push(cx); cx += c.w; });
  const right = cx;

  const drawHeader = () => {
    doc.setFillColor(241, 245, 249);
    doc.rect(M, y - 4.5, right - M, 7, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    doc.setTextColor(30);
    cols.forEach((c, i) => {
      const tx = c.a === "right" ? xs[i] + c.w - 1.5 : xs[i] + 1.5;
      doc.text(c.t, tx, y, { align: c.a === "right" ? "right" : "left" });
    });
    y += 5;
    doc.setTextColor(0);
  };
  drawHeader();

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  let tOn = 0, tSp = 0, tCo = 0;
  (pratiche || []).forEach((p) => {
    if (y > 282) {
      doc.addPage();
      y = 18;
      drawHeader();
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
    }
    tOn += Number(p.onorari || 0);
    tSp += Number(p.spese || 0);
    tCo += Number(p.compenso || 0);
    cols.forEach((c, i) => {
      let val = c.money ? formatEuro(p[c.k]) : String(p[c.k] == null ? "" : p[c.k]);
      if (c.k === "cliente") val = doc.splitTextToSize(val, c.w - 2)[0] || "";
      const tx = c.a === "right" ? xs[i] + c.w - 1.5 : xs[i] + 1.5;
      doc.text(val, tx, y, { align: c.a === "right" ? "right" : "left" });
    });
    y += 5.5;
    doc.setDrawColor(226, 232, 240);
    doc.line(M, y - 3.5, right, y - 3.5);
  });

  y += 2;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  const colEnd = (k) => { const i = cols.findIndex((c) => c.k === k); return xs[i] + cols[i].w - 1.5; };
  doc.text("Totale compensi dovuti", colEnd("stato"), y, { align: "right" });
  if (showOnorari) doc.text(formatEuro(tOn), colEnd("onorari"), y, { align: "right" });
  if (showSpese) doc.text(formatEuro(tSp), colEnd("spese"), y, { align: "right" });
  doc.text(formatEuro(tCo), colEnd("compenso"), y, { align: "right" });

  const fn = `riepilogo-compensi-${String(segnalatore || "segnalatore").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.pdf`;
  doc.save(fn);
}
